import {
  ConfirmPasswordValidationCodeInput,
  ConfirmPasswordValidationCodeResponse,
  SendPasswordValidationCodeInput,
  SendPasswordValidationCodeResponse,
  UpdatePasswordInput,
} from "@_types/password";
import {
  ConfirmContactValidationCodeInput,
  ConfirmContactValidationCodeResponse,
  SendContactValidationCodeInput,
  SendContactValidationCodeResponse,
  UpdateUserInput,
  UpdateUserResponse,
} from "@_types/users";
import { api } from "@services/apiClient";
import { AxiosPromise } from "axios";

export const confirmContactValidationCode = (
  data: ConfirmContactValidationCodeInput
): AxiosPromise<ConfirmContactValidationCodeResponse> => {
  return api.post(`/user/contact-update/confirm`, { ...data });
};

export const confirmPasswordValidationCode = (
  data: ConfirmPasswordValidationCodeInput
): AxiosPromise<ConfirmPasswordValidationCodeResponse> => {
  return api.post(`/users/password-update/confirm`, { ...data });
};

export const sendContactValidationCode = (
  data: SendContactValidationCodeInput
): AxiosPromise<SendContactValidationCodeResponse> => {
  return api.post(`/user/contact-update/send-code`, { ...data });
};

export const sendPasswordValidationCode = (
  data: SendPasswordValidationCodeInput
): AxiosPromise<SendPasswordValidationCodeResponse> => {
  return api.post(`/users/password-update/send-code`, { ...data });
};

export const updateDefaultCompany = (companyUuid: string): AxiosPromise<{ uuid: string }> => {
  return api.put(`/users/company-default`, { companyUuid });
};

export const updatePassword = (
  data: UpdatePasswordInput
): AxiosPromise<{ uuid: string; token: string; refreshToken: string; message: string }> => {
  return api.put(`/users/update-password`, { ...data });
};

export const updateUser = (data: UpdateUserInput): AxiosPromise<UpdateUserResponse> => {
  return api.put(`/users`, { ...data });
};
